import { Modal, Row, Col, Button } from "antd";
import { CheckCircle } from "lucide-react";
import React from "react";

interface SuccessModalProps {
  showModal: boolean;
  onCancel: () => void;
  title?: string;
  body?: string;
  footer?: React.ReactNode;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  showModal,
  onCancel,
  title = "Action Successful",
  body,
  footer,
}) => {
  return (
    <Modal
      open={showModal}
      onCancel={onCancel}
    //   footer={
    //     footer ?? (
    //       <Row justify="center" className="mt-2">
    //         <Col>
    //           <Button type="primary" onClick={onCancel}>
    //             Close
    //           </Button>
    //         </Col>
    //       </Row>
    //     )
    //   }
      footer={null}
      maskClosable={false}
    >
      <Row justify="center" className="py-4">
        <Col span={24} className="flex justify-center">
          <CheckCircle className="text-green-500 mt-2" size={60} />
        </Col>
        <Col span={24} className="flex justify-center mt-2">
          <span className="text-center font-semibold text-base">{title}</span>
        </Col>
        {body && (
          <Col span={24} className="flex justify-center mt-1">
            <span className="text-[13px] text-gray-500 text-center">{body}</span>
          </Col>
        )}
      </Row>
    </Modal>
  );
};

export default SuccessModal;